namespace RioERP.Masters {
    export namespace WhatsAppGatewaySettingsService {
        export const baseUrl = 'Masters/WhatsAppGatewaySettings';

        export declare function Create(request: Serenity.SaveRequest<WhatsAppGatewaySettingsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<WhatsAppGatewaySettingsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<WhatsAppGatewaySettingsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WhatsAppGatewaySettingsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Masters/WhatsAppGatewaySettings/Create",
            Update = "Masters/WhatsAppGatewaySettings/Update",
            Delete = "Masters/WhatsAppGatewaySettings/Delete",
            Retrieve = "Masters/WhatsAppGatewaySettings/Retrieve",
            List = "Masters/WhatsAppGatewaySettings/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>WhatsAppGatewaySettingsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
